import axios from "axios";

// Moving between Control Centre and Careers without signing in again. The
// access token never goes in a URL: the sender asks for a one-time code, the
// receiver swaps it for its own session. The code rides in the #fragment so it
// isn't sent to the server or logged.

const API = process.env.REACT_APP_USER_BASE_URL;

// Opens appUrl in a new tab, signed in if a code can be had. The tab is opened
// before the request so the popup blocker allows it.
export const openSignedIn = async (appUrl) => {
  const tab = window.open("", "_blank");
  if (tab) tab.opener = null;
  let url = appUrl;
  try {
    const res = await axios.post(`${API}/tutor/handoff-code`);
    const code = res.data?.result?.code;
    if (code) url = `${appUrl}#handoff=${encodeURIComponent(code)}`;
  } catch {
    // Open the app anyway; it will ask for a login.
  }
  if (tab) tab.location.href = url;
  else window.location.href = url;
};

// The code this page was opened with, removed from the address bar.
export const takeHandoffCode = () => {
  const params = new URLSearchParams(window.location.hash.slice(1));
  const code = params.get("handoff");
  if (!code) return null;
  params.delete("handoff");
  const rest = params.toString();
  window.history.replaceState(
    {},
    "",
    window.location.pathname + window.location.search + (rest ? `#${rest}` : "")
  );
  return code;
};

export const hasHandoffCode = () =>
  new URLSearchParams(window.location.hash.slice(1)).has("handoff");

export const exchangeHandoffCode = async (code) => {
  const res = await axios.post(
    `${API}/tutor/handoff`,
    { code },
    { headers: { authorization: "" } }
  );
  return res.data.result;
};
